import { VariantProps, cva } from 'class-variance-authority';
import React from 'react';
import { FlexProps } from '../../primitives';
import { IconName } from '../../primitives/Icon/Icon.types';

export const disabledCssClasses =
  'disabled:cursor-not-allowed disabled:opacity-50';

export const disabledOutlineClasses =
  'focus-visible:outline-none focus:outline-none focus-visible:ring-inset';

export const formControlWrapperVariants = cva(
  'relative flex flex-row items-center w-full',
  {
    variants: {
      variant: {
        default:
          'bg-primary-background dark:bg-transparent px-2 rounded-md border border-input shadow-sm transition-colors focus:outline-none focus-visible:ring-inset focus-visible:outline-amber-500',
        unstyled: 'rounded-none border-none bg-transparent shadow-none focus-visible:ring-inset'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
);

export interface FormControlWrapperOptions {
  id?: string;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  isInvalid?: boolean;
  isRequired?: boolean;
  isOptional?: boolean;
  isLoading?: boolean;
  placeholder?: string;
  error?: React.ReactNode;
  success?: React.ReactNode;
  helperText?: React.ReactNode;
  label?: React.ReactNode;
  description?: React.ReactNode;
  leftSlot?: React.ReactNode[];
  rightSlot?: React.ReactNode[];
  maxLength?: number;
  minLength?: number;
  showCounter?: boolean;
}

export interface FormControlWrapperState extends FormControlWrapperOptions {
  charactersCounter: number;
  setCharactersCounter: (value: number) => void;
}

export interface FormControlWrapperProps
  extends React.PropsWithChildren,
    FormControlWrapperOptions,
    VariantProps<typeof formControlWrapperVariants> {
  className?: string;
  leftIcon?: IconName | React.ReactNode;
  rightIcon?: IconName | React.ReactNode;
  enableSlotsInputFocus?: boolean;
  enableWrapperInputFocus?: boolean;
  wrapperClassName?: string;
  hideEmptyMessages?: boolean;
  wrapperRef?: React.LegacyRef<HTMLInputElement>;
}

export interface FormControlLabelProps
  extends React.PropsWithChildren<React.LabelHTMLAttributes<HTMLLabelElement>> {
  isRequired?: boolean;
  isOptional?: boolean;
  htmlFor?: string;
}

export interface FormControlSlotProps
  extends React.PropsWithChildren,
    FlexProps {}

export const FormControlWrapperForwardedProps = [
  'isDisabled',
  'isReadOnly',
  'isInvalid',
  'isRequired',
  'isOptional',
  'error',
  'success',
  'label',
  'id',
  'leftIcon',
  'rightIcon',
  'helperText',
  'leftSlot',
  'rightSlot',
  'className',
  'wrapperClassName',
  'minLength',
  'maxLength',
  'showCounter',
  'description',
  'hideEmptyMessages',
  'wrapperRef'
] as (keyof FormControlWrapperProps)[];
